import { useState } from 'react';

import { useAuditLog } from '../../hooks/use-audit';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Skeleton } from '../ui/skeleton';

export function AuditLogTable() {
  const [actor, setActor] = useState('');
  const [resourceType, setResourceType] = useState('');
  const [cursor, setCursor] = useState<string | undefined>(undefined);
  const { data, isLoading, isError } = useAuditLog({
    actor: actor || undefined,
    resource_type: resourceType || undefined,
    cursor,
  });

  function applyFilters(e: React.FormEvent) {
    e.preventDefault();
    setCursor(undefined);
  }

  return (
    <div>
      <form onSubmit={applyFilters} className="mb-2 flex gap-2">
        <Input placeholder="Actor user ID" value={actor} onChange={(e) => setActor(e.target.value)} aria-label="Actor user ID" />
        <Input
          placeholder="Тип ресурса"
          value={resourceType}
          onChange={(e) => setResourceType(e.target.value)}
          aria-label="Тип ресурса"
        />
        <Button type="submit" variant="secondary">
          Применить
        </Button>
      </form>

      {isLoading && <Skeleton className="h-40 w-full" />}
      {isError && <div className="text-sm text-red-600">Не удалось загрузить аудит-лог.</div>}
      {!isLoading && !isError && (
        <>
          <table className="w-full text-sm">
            <thead className="bg-muted/60 text-left text-xs uppercase text-muted-fg">
              <tr>
                <th className="px-3 py-2">Время</th>
                <th className="px-3 py-2">Действие</th>
                <th className="px-3 py-2">Ресурс</th>
                <th className="px-3 py-2">Актор</th>
              </tr>
            </thead>
            <tbody>
              {(data?.items ?? []).map((e) => (
                <tr key={e.id} className="border-b border-border">
                  <td className="px-3 py-2 text-xs">{new Date(e.at).toLocaleString('ru-RU')}</td>
                  <td className="px-3 py-2">{e.action}</td>
                  <td className="px-3 py-2 text-xs text-muted-fg">
                    {e.resourceType} {e.resourceId ? `#${e.resourceId.slice(0, 8)}` : ''}
                  </td>
                  <td className="px-3 py-2 text-xs text-muted-fg">{e.actorUserId ?? 'система'}</td>
                </tr>
              ))}
              {(data?.items.length ?? 0) === 0 && (
                <tr>
                  <td colSpan={4} className="px-3 py-6 text-center text-sm text-muted-fg">
                    Записей не найдено
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="mt-2 flex justify-end">
            <Button variant="secondary" size="sm" disabled={!data?.nextCursor} onClick={() => setCursor(data?.nextCursor ?? undefined)}>
              Ещё
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
